import * as React from "react";

import {rpAppLink} from "@pg-mono/rp-routes";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {rpCommonUrl} from "../../app/read_rp_environment_variables";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {ArticleDetailPerson} from "../actions/IArticleDetail";

interface IProps {
    article: {
        author?: ArticleDetailPerson | null;
        expert?: ArticleDetailPerson | null;
        date_published: string | null;
        date_content_changed: string;
        gallery: (
            | {
                  image: {
                      g_img_1160x638: string;
                  } | null;
                  image_url: string | null;
              }
            | undefined
        )[];
        id: number;
        ratings: {
            total: number;
            average: number | null;
        };
        slug: string;
        title: string;
    };
}

export const SchemaArticleDetail: React.FunctionComponent<IProps> = (props) => {
    const {article} = props;
    const firstGalleryItem = article.gallery[0];
    const averageRatingValue = article.ratings.average && article.ratings.average >= 4 ? article.ratings.average : null;
    const aggregateRating = averageRatingValue
        ? {
              "@type": "AggregateRating",
              bestRating: "5",
              worstRating: "1",
              reviewCount: article.ratings.total,
              ratingValue: averageRatingValue
          }
        : undefined;

    const authorUrl = article.author ? buildPersonUrl(article.author) : undefined;
    const authorSameAs = article.author ? buildPersonSameAs(article.author) : undefined;
    const author = article.author
        ? {
              "@type": "Person",
              name: article.author.name,
              jobTitle: article.author.job_title || "Autor rynekpierwotny.pl",
              ...(authorUrl ? {url: authorUrl} : {}),
              ...(authorSameAs ? {sameAs: authorSameAs} : {})
          }
        : undefined;

    const expertUrl = article.expert ? buildPersonUrl(article.expert) : undefined;
    const expertSameAs = article.expert ? buildPersonSameAs(article.expert) : undefined;
    const reviewedBy = article.expert
        ? {
              "@type": "Person",
              name: article.expert.name,
              ...(article.expert.job_title ? {jobTitle: article.expert.job_title} : {}),
              ...(expertUrl ? {url: expertUrl} : {}),
              ...(expertSameAs ? {sameAs: expertSameAs} : {})
          }
        : undefined;

    const json = {
        "@context": "https://schema.org",
        "@type": "Article",
        headline: article.title,
        datePublished: article.date_published ? formatDate(article.date_published, dateTimeFormat.dashedDateFormat) : undefined,
        dateModified: formatDate(article.date_content_changed, dateTimeFormat.dashedDateFormat),
        image: getThumbnailLink(firstGalleryItem?.image_url, 1160, 638) ?? firstGalleryItem?.image?.g_img_1160x638 ?? undefined,
        author,
        reviewedBy,
        publisher: {
            "@type": "Organization",
            name: "Rynek Pierwotny",
            logo: {
                "@type": "ImageObject",
                url: `${rpCommonUrl}/static-rp/a260ff6b3c9511d7.png`
            }
        },
        isPartOf: {
            "@type": "CreativeWorkSeries",
            name: article.title,
            ...(aggregateRating ? {aggregateRating} : {})
        }
    };

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />;
};
//utils
const buildPersonSameAs = (person: ArticleDetailPerson) => {
    const links = [person.website, person.linkedin, person.twitter, person.facebook].filter(Boolean);
    return links.length > 0 ? links : undefined;
};

const buildPersonUrl = (person: ArticleDetailPerson) => {
    return person.is_featured ? `${rpCommonUrl}${rpAppLink.article.author.detail({authorId: person.id, authorSlug: person.slug})}` : undefined;
};
import * as React from "react";

import {rpAppLink} from "@pg-mono/rp-routes";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {rpCommonUrl} from "../../app/read_rp_environment_variables";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {ArticleDetailPerson} from "../actions/IArticleDetail";

interface IProps {
    article: {
        author?: ArticleDetailPerson | null;
        expert?: ArticleDetailPerson | null;
        date_published: string | null;
        date_content_changed: string;
        gallery: (
            | {
                  image: {
                      g_img_1160x638: string;
                  } | null;
                  image_url: string | null;
              }
            | undefined
        )[];
        id: number;
        ratings: {
            total: number;
            average: number | null;
        };
        slug: string;
        title: string;
    };
}

export const SchemaArticleDetail: React.FunctionComponent<IProps> = (props) => {
    const {article} = props;
    const firstGalleryItem = article.gallery[0];
    const averageRatingValue = article.ratings.average && article.ratings.average >= 4 ? article.ratings.average : null;
    const aggregateRating = averageRatingValue
        ? {
              "@type": "AggregateRating",
              bestRating: "5",
              worstRating: "1",
              reviewCount: article.ratings.total,
              ratingValue: averageRatingValue
          }
        : undefined;

    const authorUrl = article.author ? buildPersonUrl(article.author) : undefined;
    const authorSameAs = article.author ? buildPersonSameAs(article.author) : undefined;
    const author = article.author
        ? {
              "@type": "Person",
              name: article.author.name,
              jobTitle: article.author.job_title || "Autor rynekpierwotny.pl",
              ...(authorUrl ? {url: authorUrl} : {}),
              ...(authorSameAs ? {sameAs: authorSameAs} : {})
          }
        : undefined;

    const expertUrl = article.expert ? buildPersonUrl(article.expert) : undefined;
    const expertSameAs = article.expert ? buildPersonSameAs(article.expert) : undefined;
    const reviewedBy = article.expert
        ? {
              "@type": "Person",
              name: article.expert.name,
              ...(article.expert.job_title ? {jobTitle: article.expert.job_title} : {}),
              ...(expertUrl ? {url: expertUrl} : {}),
              ...(expertSameAs ? {sameAs: expertSameAs} : {})
          }
        : undefined;

    const json = {
        "@context": "https://schema.org",
        "@type": "Article",
        headline: article.title,
        datePublished: article.date_published ? formatDate(article.date_published, dateTimeFormat.dashedDateFormat) : undefined,
        dateModified: formatDate(article.date_content_changed, dateTimeFormat.dashedDateFormat),
        image: getThumbnailLink(firstGalleryItem?.image_url, 1160, 638) ?? firstGalleryItem?.image?.g_img_1160x638 ?? undefined,
        author,
        reviewedBy,
        publisher: {
            "@type": "Organization",
            name: "Rynek Pierwotny",
            logo: {
                "@type": "ImageObject",
                url: `${rpCommonUrl}/static-rp/a260ff6b3c9511d7.png`
            }
        },
        isPartOf: {
            "@type": "CreativeWorkSeries",
            name: article.title,
            ...(aggregateRating ? {aggregateRating} : {})
        }
    };

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />;
};
//utils
const buildPersonSameAs = (person: ArticleDetailPerson) => {
    const links = [person.website, person.linkedin, person.twitter, person.facebook].filter(Boolean);
    return links.length > 0 ? links : undefined;
};

const buildPersonUrl = (person: ArticleDetailPerson) => {
    return person.is_featured ? `${rpCommonUrl}${rpAppLink.article.author.detail({authorId: person.id, authorSlug: person.slug})}` : undefined;
};
